import { css } from 'aphrodite/no-important';
import { IGenericObject } from 'models';
import React, { FC, useLayoutEffect, useRef } from 'react';
import Modal from 'react-modal';
import { CloseIcon } from 'util/icons';
import { style } from './style';

Modal.setAppElement('#root');

interface Options {
  fillSmallerScreens?: boolean;
  preventScroll?: boolean;
}

interface Props {
  isOpen: boolean;
  showCloseIcon?: boolean;
  confirmationButtonRef?: HTMLButtonElement | null;
  customStyles?: IGenericObject;
  options?: Options;

  onRequestClose: () => any;
  onConfirmation?: () => any;
  [x: string]: any;
}

export const ModalWrapper: FC<Props> = ({
  isOpen,
  showCloseIcon = true,
  onRequestClose,
  confirmationButtonRef,
  onConfirmation,
  customStyles = {},
  options = {},
  ...rest
}) => {
  const styles = style(customStyles, options);
  const scrollPosition = useRef<number>();

  if (confirmationButtonRef)
    confirmationButtonRef.onclick = () => {
      if (onConfirmation) onConfirmation();
      handleClose();
    };

  useLayoutEffect(() => {
    const $body = document.body;
    if (isOpen) {
      // Save the user's current scroll position so that when the modal is closed the user will be at the same position
      scrollPosition.current = window.pageYOffset;
      $body.style.overflow = 'hidden';
      $body.style.position = 'fixed';
      $body.style.width = '100%';
      $body.style.top = `-${scrollPosition.current}px`;
    }
  }, [isOpen]);

  const handleClose = () => {
    // Unlock body scrolling and restore the scroll position
    const $body = document.body;
    $body.style.removeProperty('overflow');
    $body.style.removeProperty('position');
    $body.style.removeProperty('top');
    $body.style.removeProperty('width');
    window.scrollTo(0, scrollPosition.current || 0);

    onRequestClose();
  };

  return (
    <Modal
      closeTimeoutMS={300}
      isOpen={isOpen}
      className={css(styles.modalContent)}
      overlayClassName={css(styles.overlay)}
      shouldCloseOnOverlayClick={true}
      onRequestClose={handleClose}
      {...rest}>
      {showCloseIcon ? (
        <div className={css(styles.close)}>
          <button type='button' onClick={handleClose}>
            <CloseIcon color={customStyles?.closeButton?.color} />
          </button>
        </div>
      ) : null}
      <div className={css(styles.mainContent)}>{rest.children}</div>
    </Modal>
  );
};
